module.exports = __webpack_public_path__ + "3c292d3da459def8a9c9a7a4b6359b86.MP3";